import { c as _c } from "react/compiler-runtime";
import { Button, CloseButton, Dialog, Portal, Text, VStack } from '@chakra-ui/react';
import { WIL_DISPLAY_NAME } from '@src/components/sco/Advisors/constants';
import { WilMiniProfile } from '@src/components/sco/Advisors/layout/WilMiniProfile';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { LuSparkles } from 'react-icons/lu';
type WilWhoIsModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/**
 * Portaled “Who is Wil.ai?” explainer modal — shared by aside profile and Ask list.
 *
 * Layout follows common product-explainer patterns (Circle / Ferndesk / Productboard):
 * clean title header, scrollable body, sticky full-width primary CTA + muted caption.
 */
export const WilWhoIsModal = t0 => {
  const $ = _c(19);
  const {
    open,
    onOpenChange
  } = t0;
  const paths = useAdvisorsPaths();
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = event => onOpenChange(event.open);
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Dialog.Backdrop bg="blackAlpha.700" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VStack align="flex-start" flex={1} gap={1} minWidth={0} paddingRight={10}><Dialog.Title fontSize="xl" fontWeight="semibold" letterSpacing="-0.02em" lineHeight="short">Who is Wil.ai?</Dialog.Title><Dialog.Description color="colorPalette.fg/60" fontSize="sm" lineHeight="short">Always-on AI advisor, grounded in real founder outcomes</Dialog.Description></VStack>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Dialog.Header alignItems="flex-start" borderBottomWidth="1px" borderColor="colorPalette.border/50" paddingBottom={4} paddingTop={5} paddingX={6} position="relative">{t3}<Dialog.CloseTrigger asChild={true} insetEnd={3} position="absolute" top={3}><CloseButton size="sm" /></Dialog.CloseTrigger></Dialog.Header>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Dialog.Body overflowY="auto" paddingBottom={4} paddingTop={5} paddingX={6}><WilMiniProfile hideCta={true} hideHeader={true} /></Dialog.Body>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onOpenChange) {
    t6 = () => onOpenChange(false);
    $[6] = onOpenChange;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LuSparkles />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== paths.ask || $[10] !== t6) {
    t8 = <Button asChild={true} size="md" variant="cta" width="full"><NextLink href={paths.ask} onClick={t6}>{t7}Ask {WIL_DISPLAY_NAME}</NextLink></Button>;
    $[9] = paths.ask;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Text color="colorPalette.fg/45" fontSize="xs" fontWeight="medium" letterSpacing="0.02em" textAlign="center">Free · Always on</Text>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8) {
    t10 = <Portal>{t2}<Dialog.Positioner paddingX={4}><Dialog.Content bgColor="colorPalette.container" borderColor="colorPalette.border" borderRadius="2xl" borderWidth="1px" boxShadow="xl" maxHeight="88vh" maxWidth="540px" overflow="hidden" width="full">{t4}{t5}<Dialog.Footer alignItems="stretch" bg="colorPalette.container" borderColor="colorPalette.border/50" borderTopWidth="1px" flexDirection="column" gap={2} paddingBottom={5} paddingTop={4} paddingX={6}>{t8}{t9}</Dialog.Footer></Dialog.Content></Dialog.Positioner></Portal>;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== open || $[16] !== t1 || $[17] !== t10) {
    t11 = <Dialog.Root motionPreset="scale" open={open} placement="center" scrollBehavior="inside" size="md" onOpenChange={t1}>{t10}</Dialog.Root>;
    $[15] = open;
    $[16] = t1;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};